import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetMasterReport(filters) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/masterReport",
        params: { filters },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetMasterReportTask(taskId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/masterReport/task/" + taskId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetReportClients() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/clientList",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetReportAccounts(client) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/accountList",
        params: { client },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetReportUsers() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/userList",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetProjectProfitability(startDate, endDate) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/projectProfitability",
        params: { startDate, endDate },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetRetainers(startDate, endDate) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/retainers",
        params: { startDate, endDate },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetResourceUtilization(startDate, endDate, groupByMonth) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/resourceUtilization",
        params: { startDate, endDate, groupByMonth },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetDailyHours(startDate, endDate) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/dailyHours",
        params: { startDate, endDate },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetMyDailyHours(startDate, endDate) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/myDailyHours",
        params: { startDate, endDate },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetReportDepartments() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/departmentList",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetArAging() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/arAging",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetHoursPosted(startDate, endDate) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/hoursPosted",
        params: { startDate, endDate },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetProfitabilityTrend(startDate, endDate) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/reports/profitabilityTrend",
        params: { startDate, endDate },
        withCredentials: true,
        crossorigin: true
    });
}